import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Standard: sobald ein Inline-Formular oben geöffnet wird, nach oben scrollen
export const useScrollToTopWhen = (active) => {
  useEffect(() => { if (active) window.scrollTo({ top: 0, behavior: "smooth" }); }, [active]);
};

// Global: bei jedem Seitenwechsel nach oben (außer Anker-Links mit #hash)
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) { const el = document.getElementById(hash.slice(1)); if (el) { el.scrollIntoView({ behavior: "smooth" }); return; } }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};
